import { observer } from "mobx-react-lite";
import React, { FC, FormEvent, useContext, useState } from "react";
import { Context } from "..";
import ReactInputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";

const RegistrationForm: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordSecond, setPasswordSecond] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [middleName, setMiddleName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [workPlace, setWorkPlace] = useState<string>("");
  const [diplomaNumber, setDiplomaNumber] = useState<string>("");
  const { store } = useContext(Context);
  const navigate = useNavigate();

  const onSubmitHandler = async (evt: FormEvent) => {
    evt.preventDefault();
    const response = await store.registration(email, password, Number(phone.replace(/[^0-9]/g, '')), firstName, lastName, middleName, workPlace, diplomaNumber);
    if (response) {
      const formBlock = document.querySelector(".form__block");
      const formSubmit = document.querySelector(".form__submit");
      const formInputs = formBlock?.querySelectorAll(".form__input");
      formInputs?.forEach((input) => {
        input.classList.add("invalid");
      })
      const errorBlock = formBlock?.querySelector(".form__error");
      formBlock?.classList.add("shake");
      setTimeout(() => {
        formBlock?.classList.remove("shake");
      }, 500);
      if (errorBlock) {
        return;
      }
      const error = document.createElement("div");
      error.classList.add("form__error");
      error.textContent = response;
      formBlock?.insertBefore(error, formSubmit);
    } else {
      const formBlocks = document.querySelectorAll(".form__block");
      formBlocks.forEach((block) => {
        if (block.classList.contains('form__block--visible')) {
          block.classList.add("form__block--hidden");
          block.classList.remove("form__block--visible");
        } else {
          block.classList.remove("form__block--hidden");
          block.classList.add("form__block--visible");
        }
      })
      setTimeout(() => navigate("/"), 5000);
    }
  }

  return (
    <div className="form form--two">
      <form className="form__block form__block--visible" onSubmit={onSubmitHandler}>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-last-name">Ваше прізвище</label>
          <input
            className="form__input"
            onChange={(e) => {
              setLastName(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            minLength={1}
            inputMode="text"
            value={lastName}
            type="text"
            placeholder="Ваше прізвище"
            id="form-last-name"
            autoComplete="last name"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-first-name">Ваше ім'я</label>
          <input
            className="form__input"
            onChange={(e) => {
              setFirstName(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            inputMode="text"
            minLength={1}
            value={firstName}
            type="text"
            placeholder="Ваше ім'я"
            id="form-first-name"
            autoComplete="name"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-middle-name">По батькові</label>
          <input
            className="form__input"
            onChange={(e) => {
              setMiddleName(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            inputMode="text"
            minLength={1}
            value={middleName}
            type="text"
            placeholder="По батькові"
            id="form-middle-name"
            autoComplete="middle name"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-work-place">Ваше місце роботи</label>
          <input
            className="form__input"
            onChange={(e) => {
              setWorkPlace(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            inputMode="text"
            value={workPlace}
            type="text"
            placeholder="Ваше місце роботи"
            id="form-work-place"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-diploma-number">Ваш номер диплому</label>
          <input
            className="form__input"
            onChange={(e) => {
              setDiplomaNumber(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            inputMode="text"
            value={diplomaNumber}
            type="text"
            placeholder="Ваш номер диплому"
            id="form-diploma-number"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-email">Ваш email</label>
          <input
            className="form__input"
            onChange={(e) => {
              setEmail(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            inputMode="email"
            value={email}
            type="email"
            placeholder="Ваш email"
            id="form-email"
            autoComplete="email"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-phone">Ваш телефон</label>
          <ReactInputMask
            mask="+38(099)999 99 99"
            className="form__input"
            onChange={(e) => {
              setPhone(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
            }}
            pattern="^(?:\+38)?(\(\d{3}\)[\s]?[0-9]{3}[\s]?[0-9]{2}[\s]?[0-9]{2})$"
            inputMode="tel"
            value={phone}
            type="text"
            placeholder="Ваш телефон"
            id="form-phone"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-password">Введіть пароль</label>
          <input
            className="form__input form__input--password"
            onChange={(e) => {
              setPassword(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
              const match = e.target.value.match(/^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[\w!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/);
              if (e.target.value.length < 8) {
                e.target.setCustomValidity("Пароль має бути мінімум з 8 знаків")
              }
              if (!/\d/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити цифру")
              }
              if (!/[A-Z]/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити велику літеру")
              }
              if (!/[a-z]/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити маленьку літеру")
              }
              if (!/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити спеціальний символ")
              }
              if (match) {
                e.target.setCustomValidity("");
                if (passwordSecond === "") return;
                else {
                  const input = document.querySelector("input.form__input--password-second") as HTMLInputElement;
                  input?.setCustomValidity("")
                }
                if (passwordSecond !== e.target.value) {
                  e.target.setCustomValidity("Паролі не співпадають")
                }
                else {
                  e.target.setCustomValidity("")
                }
              }
            }}
            inputMode="text"
            value={password}
            type="password"
            placeholder="Введіть пароль"
            id="form-password"
            autoComplete="off"
            min="8"
            required
          />
        </fieldset>
        <fieldset className="form__field">
          <label className="form__label" htmlFor="form-password-second">Підтвердіть пароль</label>
          <input
            className="form__input form__input--password-second"
            onChange={(e) => {
              setPasswordSecond(e.target.value);
              if (e.target.value.trim() !== '') {
                e.target.parentElement?.classList.add("focus");
              } else {
                e.target.parentElement?.classList.remove("focus");
              }
              if (e.target.classList.contains('invalid')) {
                e.target.classList.remove("invalid");
              }
              const match = e.target.value.match(/^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[\w!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/);
              if (e.target.value.length < 8) {
                e.target.setCustomValidity("Пароль має бути мінімум з 8 знаків")
              }
              if (!/\d/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити цифру")
              }
              if (!/[A-Z]/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити велику літеру")
              }
              if (!/[a-z]/.test(e.target.value)) {
                e.target.setCustomValidity("Пароль має містити маленьку літеру")
              }
              if (match) {
                e.target.setCustomValidity("");
                if (password === "") return;
                else {
                  const input = document.querySelector("input.form__input--password") as HTMLInputElement;
                  input?.setCustomValidity("")
                }
                if (password !== e.target.value) {
                  e.target.setCustomValidity("Паролі не співпадають")
                }
                else {
                  e.target.setCustomValidity("")
                }
              }
            }}
            inputMode="text"
            value={passwordSecond}
            type="password"
            placeholder="Підтвердіть пароль"
            id="form-password-second"
            autoComplete="off"
            required
          />
        </fieldset>
        <button className="form__submit" type="submit">
          Реєстрація
        </button>
      </form>
      <div className="form__block form__block--successful form__block--hidden">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle cx="25" cy="25" r="25" fill="#25ae88" /><path fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M38 15 22 33l-10-8" /></svg>
        <p className="form__text">Вас успішно зареєстровано, підтвердіть пошту</p>
      </div>
    </div>
  );
};

export default observer(RegistrationForm);
